/**
 * Interfaces de configuracao do EntitySelectorComponent.
 *
 * Estrategia para DEFAULT_ENTITY_COLUMNS:
 * Os headers sao definidos como string vazia e preenchidos em runtime
 * via translate.instant('entity-selector.headers.*') no ngOnInit do componente.
 * Isso permite que o componente funcione com colunas padrao sem exigir
 * que o pai informe headers traduzidos.
 */

export interface EntitySelectorConfig {
  /** Filtro de categoria para API: 'categoriaCliente=true' ou 'categoriaFornecedor=true' */
  categoryFilter: string;

  /** Placeholder do autocomplete */
  placeholder: string;

  /** Icone do label (ex: 'pi pi-users') */
  labelIcon?: string;

  /** Classe CSS do icone do label (ex: 'contact-color') */
  labelIconClass?: string;

  /** Mostrar botao "+" externo para adicionar nova entidade */
  showAddButton?: boolean;

  /** Mostrar opcao "+ Agregar" dentro do dropdown do autocomplete */
  showAddInDropdown?: boolean;

  /** Tooltip do botao "+" (ja traduzido) */
  addButtonTooltip?: string;

  /** Colunas visiveis no dialog (default: colunas padrao de pessoa) */
  dialogColumns?: EntitySelectorColumn[];

  /** Titulo do dialog (ja traduzido) */
  dialogTitle?: string;

  /** Subtitulo do dialog (ja traduzido) */
  dialogSubtitle?: string;

  /** Icone do header do dialog (default: 'pi pi-users') */
  dialogIcon?: string;

  /** Mensagem quando nenhum registro e encontrado (ja traduzida) */
  emptyMessage?: string;
}

export interface EntitySelectorColumn {
  /** Campo do PessoaDTO (ex: 'codigoPessoa', 'nome', 'cidade.nome') */
  field: string;

  /** Header da coluna (ja traduzido) */
  header: string;

  /** Se a coluna e ordenavel (default: true) */
  sortable?: boolean;

  /** Largura CSS da coluna (ex: '100px', '150px') */
  width?: string;
}

/**
 * Colunas padrao quando dialogColumns nao e informado.
 * Os headers vazios sao preenchidos em runtime via translate.instant().
 * @see EntitySelectorComponent.buildDefaultColumns()
 */
export const DEFAULT_ENTITY_COLUMNS: EntitySelectorColumn[] = [
  { field: 'codigoPessoa', header: '', sortable: true, width: '100px' },
  { field: 'nome', header: '', sortable: true },
  { field: 'fantasia', header: '', sortable: true },
  { field: 'telefone', header: '', sortable: true, width: '150px' },
  { field: 'ci', header: '', sortable: true, width: '100px' },
  { field: 'ruc', header: '', sortable: true, width: '110px' },
  { field: 'cidade.nome', header: '', sortable: true, width: '120px' },
];
